import React from "react";
import "./Features.css";
const Features = () => {
  return (
    <section className="map">
      <div className="containmap">
        <div className="container card-text">
          <div className="row">
            <div className="col-md-3">
              <div>
                <img
                  src="https://html-templates.evonicmedia.com/adventurist/assets/images/icon/feature-1.svg"
                  alt="featureIcon"
                />
                <h6>Map Location </h6>
                <p>
                  Lorem Ipsum is simply dummy <br />
                  text of the printing.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-map">
        <div className="container card-text">
          <div className="row">
            <div className="col-md-3">
              <div>
                <figure>
                  <img
                    src="https://html-templates.evonicmedia.com/adventurist/assets/images/icon/feature-2.svg"
                    alt="featureIcon"
                  />
                </figure>
                <h6>Map Location </h6>
                <p>
                  Lorem Ipsum is simply dummy <br />
                  text of the printing.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-map">
        <div className="container card-text">
          <div className="row">
            <div className="col-md-3">
              <div>
                <figure>
                  <img
                    src="https://html-templates.evonicmedia.com/adventurist/assets/images/icon/feature-4.svg"
                    alt="featureIcon"
                  />
                </figure>
                <h6>Map Location </h6>
                <p>
                  Lorem Ipsum is simply dummy <br />
                  text of the printing.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
